import { useMutation } from '@tanstack/react-query';
import { useMixpanel } from 'react-mixpanel-browser';

import {
    DeleteDeviceAlertConfigurationPayload,
    DeleteDeviceAlertConfigurationResponse,
} from '@/api/customSensorAlerts/types';
import { axios } from '@/common/axios';
import { MutationConfig, queryClient } from '@/common/react-query';

export const deleteDeviceAlertsConfiguration = ({
    spotterId,
    alertId,
}: DeleteDeviceAlertConfigurationPayload): Promise<DeleteDeviceAlertConfigurationResponse> => {
    return axios.delete(`/user-rest/devices/${spotterId}/alert-configurations/${alertId}`);
};

type UseDeleteAlertsConfigurationOptions = {
    config?: MutationConfig<typeof deleteDeviceAlertsConfiguration>;
    data?: DeleteDeviceAlertConfigurationPayload;
};

export const useDeleteAlertConfiguration = ({ config }: UseDeleteAlertsConfigurationOptions = {}) => {
    const mixpanel = useMixpanel();
    return useMutation({
        ...config,
        mutationFn: deleteDeviceAlertsConfiguration,
        onSuccess: (data, variables) => {
            queryClient.invalidateQueries({
                queryKey: ['device-alerts-configuration', { spotterId: variables.spotterId }],
            });
            mixpanel?.track('Sensor alert deleted', {
                spotterId: variables.spotterId,
                alertType: variables.alertType,
                details: variables.details,
                sensorPosition: variables.sensorPosition,
            });
        },
    });
};
